(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-business"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(c) {
      var v = Math.round(c) / 100;
      return '$' + v.toLocaleString('es-MX', { minimumFractionDigits: Math.round(c) % 100 ? 2 : 0, maximumFractionDigits: 2 });
    }

    function parse(raw) {
      try {
        var c = JSON.parse(raw);
        if (c && c.t) c.t.sort(function (a, b) { return a[0] - b[0]; });
        return c;
      } catch (e) { return null; }
    }

    function unitFor(cfg, base, q) {
      if (!cfg || !cfg.t || !cfg.t.length) return cfg && cfg.s ? Math.min(base, cfg.s) : base;
      var idx = -1;
      for (var i = 0; i < cfg.t.length; i++) if (q >= cfg.t[i][0]) idx = i;
      if (idx < 0) return base;
      var v = cfg.t[idx][1];
      return Math.max(0, Math.min(base, cfg.m === 'd' ? base - v : v));
    }

    function animateNumber(el, to, format) {
      var from = el.__v || 0;
      el.__v = to;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = format(to); return; }
      var start = performance.now();
      cancelAnimationFrame(el.__raf);
      (function step(now) {
        var t = Math.min(1, (now - start) / 450);
        var e = 1 - Math.pow(1 - t, 3);
        el.textContent = format(from + (to - from) * e);
        if (t < 1) el.__raf = requestAnimationFrame(step);
      })(start);
    }

    function initCalc(calc) {
      var prods = Array.prototype.slice.call(calc.querySelectorAll('[data-cc-calc-prod]'));
      if (!prods.length) return;
      var range = calc.querySelector('[data-cc-calc-range]');
      var qtyOut = calc.querySelector('[data-cc-calc-qty]');
      var ticks = calc.querySelector('[data-cc-calc-ticks]');
      var $ = function (s) { return calc.querySelector(s); };
      var cur = null;

      function select(btn) {
        prods.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        cur = {
          cfg: parse(btn.dataset.cfg),
          base: parseInt(btn.dataset.base, 10) || 0,
          resale: parseInt(btn.dataset.resale, 10) || 0,
          url: btn.dataset.url,
          title: btn.dataset.title
        };
        var tiers = cur.cfg && cur.cfg.t ? cur.cfg.t : [];
        var maxQ = Math.max(50, tiers.length ? tiers[tiers.length - 1][0] : 50);
        range.max = String(Math.min(maxQ, 500));
        ticks.innerHTML = tiers
          .map(function (t) {
            return '<button type="button" data-q="' + t[0] + '" style="left:' + ((t[0] - 1) / (range.max - 1)) * 100 + '%">' + t[0] + '+</button>';
          })
          .join('');
        if (+range.value > +range.max) range.value = range.max;
        if (tiers.length && +range.value < tiers[0][0]) range.value = String(Math.max(tiers[0][0], Math.min(10, +range.max)));
        render();
      }

      function render() {
        if (!cur) return;
        var q = parseInt(range.value, 10) || 1;
        var unit = unitFor(cur.cfg, cur.base, q);
        var profitU = Math.max(0, cur.resale - unit);
        var total = profitU * q;
        var margin = cur.resale > 0 ? Math.round((profitU / cur.resale) * 100) : 0;

        qtyOut.textContent = q;
        range.style.setProperty('--fill', ((q - 1) / (range.max - 1)) * 100 + '%');
        $('[data-cc-calc-cost]').textContent = fmt(unit);
        var retail = $('[data-cc-calc-retail]');
        retail.textContent = unit < cur.base ? fmt(cur.base) : '';
        $('[data-cc-calc-resale]').textContent = fmt(cur.resale);
        $('[data-cc-calc-invest]').textContent = fmt(unit * q);
        $('[data-cc-calc-margin]').textContent = margin + '%';
        animateNumber($('[data-cc-calc-profit]'), total, function (v) { return '+' + fmt(v); });

        var costPct = cur.resale > 0 ? Math.min(100, (unit / cur.resale) * 100) : 100;
        $('[data-cc-calc-barcost]').style.width = costPct + '%';
        $('[data-cc-calc-bargain]').style.width = Math.max(0, 100 - costPct) + '%';

        ticks.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-hit', q >= +b.dataset.q); });

        var next = null;
        if (cur.cfg && cur.cfg.t) {
          for (var i = 0; i < cur.cfg.t.length; i++) if (cur.cfg.t[i][0] > q) { next = cur.cfg.t[i]; break; }
        }
        var nextEl = $('[data-cc-calc-next]');
        if (next) {
          var nu = unitFor(cur.cfg, cur.base, next[0]);
          var extra = (cur.resale - nu) * next[0] - total;
          nextEl.textContent = 'Con ' + next[0] + ' pzas pagas ' + fmt(nu) + ' c/u y ganas ' + fmt(Math.max(0, extra)) + ' más.';
        } else {
          nextEl.textContent = '¡Tienes el mejor precio por pieza!';
        }

        $('[data-cc-calc-cta]').href = cur.url;
        $('[data-cc-calc-ctatext]').textContent = 'Comprar ' + q + ' pzas · ' + cur.title;
      }

      prods.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
      range.addEventListener('input', render);
      calc.querySelector('[data-cc-calc-minus]').addEventListener('click', function () { range.value = Math.max(1, +range.value - 1); render(); });
      calc.querySelector('[data-cc-calc-plus]').addEventListener('click', function () { range.value = Math.min(+range.max, +range.value + 1); render(); });
      ticks.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        range.value = b.dataset.q;
        render();
      });
      select(prods[0]);
    }

    function countUp(root) {
      root.querySelectorAll('[data-cc-count]').forEach(function (el) {
        var raw = el.dataset.ccCount;
        var target = parseFloat(String(raw).replace(/,/g, ''));
        if (isNaN(target)) return;
        var hasComma = String(raw).indexOf(',') > -1;
        el.__v = 0;
        animateNumber(el, target, function (v) {
          var n = Math.round(v);
          return hasComma ? n.toLocaleString('en-US') : String(n);
        });
      });
    }

    function init(root) {
      if (root.__ccInit) return;
      root.__ccInit = true;
      var calc = root.querySelector('[data-cc-calc]');
      if (calc) initCalc(calc);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            root.classList.add('is-in');
            countUp(root);
            io.disconnect();
          }
        }, { threshold: 0.12 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }
    }

    function boot() {
      document.querySelectorAll('[data-cc-biz]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-collection-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__ccInit) return;
      root.__ccInit = true;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            root.classList.add('is-in');
            io.disconnect();
          }
        }, { threshold: 0.15 });
        io.observe(root);
      } else {
        root.classList.add('is-in');
      }

      var track = root.querySelector('[data-cc-bento-track]');
      var bar = root.querySelector('[data-cc-bento-bar]');
      if (!track || !bar) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = track.clientWidth / Math.max(track.scrollWidth, 1);
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + pos * (100 / Math.max(ratio, 0.12) - 100) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function boot() {
      document.querySelectorAll('[data-cc-bento]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ccSortInit) return;
    window.__ccSortInit = true;
    document.addEventListener('change', function (event) {
      var select = event.target.closest && event.target.closest('[data-cc-sort]');
      if (!select) return;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__ccInit) return;
      root.__ccInit = true;

      var track = root.querySelector('[data-cc-track]');
      if (!track) return;
      var items = Array.prototype.slice.call(track.querySelectorAll('[data-cc-item]'));
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-cc-filter]'));
      var prev = root.querySelector('[data-cc-prev]');
      var next = root.querySelector('[data-cc-next]');
      var bar = root.querySelector('[data-cc-progress]');
      var none = root.querySelector('[data-cc-none]');
      var more = root.querySelector('[data-cc-more]');
      var moreT = root.querySelector('[data-cc-more-t]');
      var baseLabel = moreT ? moreT.textContent : '';

      function match(li, handle) {
        return !handle || (' ' + li.dataset.c + ' ').indexOf(' ' + handle + ' ') > -1;
      }

      // Nombre de produits par pastille ; on masque les pastilles vides
      chips.forEach(function (chip) {
        var h = chip.dataset.ccFilter;
        var n = items.filter(function (li) { return match(li, h); }).length;
        var out = chip.querySelector('[data-cc-count]');
        if (out) out.textContent = n;
        if (h && n === 0) chip.hidden = true;
      });

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var st = max <= 4;
        root.classList.toggle('is-static', st);
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          var ratio = st ? 1 : track.clientWidth / track.scrollWidth;
          bar.style.width = ratio * 100 + '%';
          bar.style.marginLeft = st ? '0' : (track.scrollLeft / track.scrollWidth) * 100 + '%';
        }
      }

      function page(dir) {
        track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
      }

      function filter(chip) {
        var h = chip.dataset.ccFilter;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var shown = 0;
        items.forEach(function (li) {
          var ok = match(li, h);
          li.hidden = !ok;
          li.classList.remove('is-in');
          if (ok) {
            shown++;
            void li.offsetWidth;
            li.classList.add('is-in');
          }
        });
        if (none) none.hidden = shown > 0;
        if (more) {
          more.href = chip.dataset.url;
          more.parentNode.hidden = shown === 0;
          if (moreT) moreT.textContent = h ? 'Ver todo ' + chip.textContent.replace(/\d+\s*$/, '').trim() : baseLabel;
        }
        track.scrollTo({ left: 0, behavior: 'auto' });
        update();
        // Centre la pastille active dans sa rangée
        var row = chip.parentNode;
        if (row.scrollWidth > row.clientWidth) {
          row.scrollTo({ left: chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2, behavior: 'smooth' });
        }
      }

      chips.forEach(function (c) { c.addEventListener('click', function () { filter(c); }); });
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function boot() {
      document.querySelectorAll('[data-cc-show]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__ccInit) return;
      root.__ccInit = true;

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-cc-step]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cc-panel]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.cc-steps__dots span'));
      var list = root.querySelector('.cc-steps__list');
      var seconds = parseFloat(root.dataset.autoplay) || 0;
      var current = 0;
      var timer = null;
      var mobile = window.matchMedia('(max-width: 899px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var visible = false;

      root.style.setProperty('--cc-step-duration', (seconds || 6) + 's');

      function activate(i, fromScroll) {
        current = (i + items.length) % items.length;
        items.forEach(function (el, k) {
          var on = k === current;
          el.classList.toggle('is-active', on);
          var btn = el.querySelector('[role="tab"]');
          if (btn) btn.setAttribute('aria-selected', on ? 'true' : 'false');
          // Relance l'animation de la barre de progression
          var bar = el.querySelector('.cc-step__bar span');
          if (bar && on) {
            bar.style.animation = 'none';
            void bar.offsetWidth;
            bar.style.animation = '';
          }
        });
        panels.forEach(function (p, k) { p.classList.toggle('is-active', k === current); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === current); });
        root.dispatchEvent(new CustomEvent('cc-step:change', { detail: { index: current } }));

        if (mobile.matches && !fromScroll && list) {
          var el = items[current];
          list.scrollTo({ left: el.offsetLeft - (list.clientWidth - el.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
        schedule();
      }

      function schedule() {
        clearTimeout(timer);
        if (!seconds || reduce || !visible || root.classList.contains('is-paused') || mobile.matches) return;
        timer = setTimeout(function () { activate(current + 1); }, seconds * 1000);
      }

      items.forEach(function (el, k) {
        var btn = el.querySelector('[role="tab"]');
        if (!btn) return;
        btn.addEventListener('click', function () { activate(k); });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); activate(k + 1); items[current].querySelector('[role="tab"]').focus(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); activate(k - 1); items[current].querySelector('[role="tab"]').focus(); }
        });
      });

      root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
      root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); schedule(); });

      // Mobile : l'étape active suit le swipe
      if (list) {
        var raf;
        list.addEventListener('scroll', function () {
          if (!mobile.matches) return;
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var center = list.scrollLeft + list.clientWidth / 2;
            var best = 0, dist = Infinity;
            items.forEach(function (el, k) {
              var d = Math.abs(el.offsetLeft + el.clientWidth / 2 - center);
              if (d < dist) { dist = d; best = k; }
            });
            if (best !== current) activate(best, true);
          });
        }, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) {
            root.classList.add('is-visible');
            activate(current, true);
          } else {
            clearTimeout(timer);
          }
        }, { threshold: 0.35 }).observe(root);
      } else {
        visible = true;
        schedule();
      }
    }

    function boot() {
      document.querySelectorAll('[data-cc-steps]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
